import { Link } from "react-router-dom";
import { homePage } from "@/mocks/home";
import ScrollReveal from "@/components/feature/ScrollReveal";

export default function HomePopularFlavors() {
  const { popularFlavors } = homePage;

  const flavorImages = [
    "https://readdy.ai/api/search-image?query=golden%20brown%20taiyaki%20red%20bean%20cake%20classic%20sweet%20red%20bean%20filling%20visible%20close-up%20food%20photography%20warm%20amber%20lighting%20Japanese%20street%20food%20crispy%20golden%20shell%20cream%20background%20appetizing&width=600&height=400&seq=home-pf-1&orientation=landscape",
    "https://readdy.ai/api/search-image?query=taiyaki%20with%20creamy%20custard%20butter%20filling%20oozing%20out%20golden%20brown%20close-up%20food%20photography%20warm%20soft%20lighting%20Japanese%20street%20snack%20rich%20cream%20filling%20appetizing&width=600&height=400&seq=home-pf-2&orientation=landscape",
    "https://readdy.ai/api/search-image?query=taiyaki%20with%20purple%20taro%20filling%20cross%20section%20showing%20thick%20purple%20paste%20close-up%20food%20photography%20warm%20lighting%20Taiwanese%20artisan%20street%20snack%20appetizing&width=600&height=400&seq=home-pf-3&orientation=landscape",
    "https://readdy.ai/api/search-image?query=taiyaki%20with%20peanut%20and%20sesame%20filling%20cross%20section%20golden%20brown%20close-up%20food%20photography%20warm%20lighting%20nutty%20aroma%20artisan%20snack%20appetizing&width=600&height=400&seq=home-pf-4&orientation=landscape",
    "https://readdy.ai/api/search-image?query=savory%20taiyaki%20with%20cheese%20filling%20golden%20brown%20crispy%20shell%20close-up%20food%20photography%20warm%20lighting%20salty%20sweet%20combination%20creative%20snack%20appetizing&width=600&height=400&seq=home-pf-5&orientation=landscape",
    "https://readdy.ai/api/search-image?query=seasonal%20limited%20edition%20taiyaki%20with%20colorful%20fruit%20filling%20creative%20Japanese%20street%20food%20warm%20lighting%20close-up%20food%20photography%20appetizing%20special%20edition&width=600&height=400&seq=home-pf-6&orientation=landscape",
  ];

  return (
    <section className="py-16 md:py-20 bg-redbean-cream">
      <div className="mx-auto px-4 md:px-6 lg:px-8" style={{ maxWidth: "1200px" }}>
        <ScrollReveal>
          <h2
            className="font-heading font-bold text-redbean-coffee text-center mb-10 md:mb-12"
            style={{ fontSize: "clamp(1.5rem, 3vw, 2.125rem)", lineHeight: 1.4 }}
          >
            {popularFlavors.title}
          </h2>
        </ScrollReveal>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5">
          {popularFlavors.flavors.map((flavor, idx) => (
            <ScrollReveal key={idx} delay={idx * 100}>
              <div
                className="bg-white rounded-card overflow-hidden shadow-soft hover:shadow-card transition-shadow duration-300 group"
              >
                <div className="w-full" style={{ height: "180px" }}>
                  <img
                    src={flavorImages[idx]}
                    alt={flavor.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <h3
                    className="font-heading font-bold text-redbean-coffee mb-1.5"
                    style={{ fontSize: "1.125rem", lineHeight: 1.45 }}
                  >
                    {flavor.name}
                  </h3>
                  <p className="text-redbean-coffee/55 text-sm leading-relaxed mb-4">
                    {flavor.desc}
                  </p>
                  <Link
                    to="/products"
                    className="inline-flex items-center gap-1 text-redbean-caramel text-sm font-medium hover:text-redbean-primary transition-colors"
                  >
                    查看產品
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-right-line" />
                    </span>
                  </Link>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}